import Modal from "../../../../global/components/Modal/Modal.vue";
import PuxButton from "../../../../global/components/PuxButton/PuxButton.vue";

import HttpMixin from "../../../../global/mixins/HttpMixin";
import {
  FilterSpacedMixin,
} from "../../../../global/mixins/FiltersMixin";

// @vue/component
export default {
  name: "AntragCopyButtonConfirm",
  components: {
    Modal,
    PuxButton,
  },
  mixins: [
    FilterSpacedMixin,
    HttpMixin,
  ],
  props: {
    antrag: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isModalOpen: false,
      confirmOptions: undefined
    };
  },
  computed: {
    antragNummerFiltered() {
      return this.filterSpaced(this.antrag.a_nr, true);
    },

    antragUrl() {
      return `foerderantraege/${ this.antrag.pk }/kopieren/`;
    },
  },
  methods: {
    openModal() {
      this.confirmOptions = {
        okClass: "btn btn-primary",
        title: "_TXT_ANTRAG_COPY_{{a_nr}}_",
        msg: "_HTML_ANTRAG_COPY_BODY_{{a_nr}}_",
        okLabel: "_BTN_ANTRAG_COPY_",
        okCallback: this.copyAntrag,
        cancelCallback: this.closeModal,
        extra: {
          a_nr: this.antragNummerFiltered,
        },
        loading: false,
      };
      this.isModalOpen = true;
    },

    closeModal() {
      this.isModalOpen = false;
    },

    copyAntrag() {
      this.confirmOptions.loading = true;
      this.postHttp({
        url: this.antragUrl,
      }).then(
        response => {
          this.addNotification({
            text: "_MSG_ANTRAG_COPY_SUCCESS_{{a_nr}}_",
            extra: {
              a_nr: this.antragNummerFiltered,
            },
          });
          this.closeModal();
          this.$goTo("root.foerderantrag.details", { id: response.pk });
        },
        () => {
          this.addNotification({
            text: "_MSG_ANTRAG_COPY_ERROR_",
            type: "error",
          });
        }
      ).finally(
        () => {
          this.confirmOptions.loading = false;
        }
      );
    },
  },
};
